import Typography from '@mui/material/Typography';

const PADDING = { padding: '0px 14px' };

export default function ResetPasswordChecks({
  isLengthOkay,
  lengthRules,
  includesUppercase,
  includesLowercase,
  containsNumber,
  containsSpecialChars,
}) {
  return (
    <>
      <Typography
        variant='body2'
        sx={{ color: isLengthOkay ? 'green' : undefined, ...PADDING }}
      >
        {`${lengthRules.min}-${lengthRules.max} characters`}
      </Typography>
      <Typography
        variant='body2'
        sx={{ color: includesUppercase ? 'green' : undefined, ...PADDING }}
      >
        Includes uppercase character
      </Typography>
      <Typography
        variant='body2'
        sx={{ color: includesLowercase ? 'green' : undefined, ...PADDING }}
      >
        Includes lowercase character
      </Typography>
      <Typography
        variant='body2'
        sx={{ color: containsNumber ? 'green' : 'undefined', ...PADDING }}
      >
        Contains a number
      </Typography>
      <Typography
        variant='body2'
        sx={{ color: containsSpecialChars ? 'green' : undefined, ...PADDING }}
      >
        Contains a special character
      </Typography>
    </>
  );
}
